export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00526.59844fbf.png";